import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import VariantBuilderPanelCollapse from "../variants/VariantBuilderPanelCollapse";

const ElementSettingsNavigationDesign = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  let variant = contextData.objects.variant;
  let element = builder.selected().object;

  let controlStyle = element.options["control-style"]
    ? element.options["control-style"]
    : "width";

  let controlStyleMobile = element.options["control-style-mobile"]
    ? element.options["control-style-mobile"]
    : controlStyle;

  let navBorderStyle = element.options["nav-border-style"]
    ? element.options["nav-border-style"]
    : variant.options["nav-border-style"];

  let navMenuBorderStyle = element.options["nav-menu-border-style"]
    ? element.options["nav-menu-border-style"]
    : variant.options["nav-menu-border-style"];

  return (
    <React.Fragment>
      <VariantBuilderPanelCollapse name="Navigation Bar" open={false}>
        <VariantBuilderSetting
          object={element}
          label="Navigation Layout"
          setting_name="[options][nav-layout]"
          setting_type="navigation_layout"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-layout"] ? element.options["nav-layout"] : ""
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Links Layout"
          setting_name="[options][nav-links-layout]"
          setting_type="layout"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-layout"]
              ? element.options["nav-links-layout"]
              : variant.options["nav-links-layout"]
              ? variant.options["nav-links-layout"]
              : "horizontal"
          }
          valueMappings={{
            responsive: "horizontal",
            stacked: "vertical",
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Container Width"
          setting_name="[options][nav-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-width"]
              ? element.options["nav-width"]
              : undefined
          }
          placeholder="Full width"
          min={0}
          max={2560}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={element}
          label="Container Width"
          setting_name="[options][nav-width-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-width-mobile"]
              ? element.options["nav-width-mobile"]
              : undefined
          }
          placeholder={
            element.options["nav-width"]
              ? element.options["nav-width"]
              : "Full width"
          }
          min={0}
          max={2560}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Container Spacing"
          setting_name="[options][nav-spacing]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-spacing"]
              ? element.options["nav-spacing"]
              : undefined
          }
          placeholder={15}
          min={0}
          max={100}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="desktop"
        />

        <VariantBuilderSetting
          object={element}
          label="Container Spacing"
          setting_name="[options][nav-spacing-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-spacing-mobile"]
              ? element.options["nav-spacing-mobile"]
              : undefined
          }
          placeholder={
            element.options["nav-spacing"] ? element.options["nav-spacing"] : 15
          }
          min={0}
          max={100}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Background Color"
          setting_name="[options][nav-background-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-background-color"]
              ? element.options["nav-background-color"]
              : undefined
          }
          placeholder={
            variant.options["nav-background-color"]
              ? variant.options["nav-background-color"]
              : "Transparent"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_id={element.id}
          label="Border Style"
          setting_name="[options][nav-border-style]"
          setting_type="border_style"
          object_type="elements"
          value={
            element.options["nav-border-style"]
              ? element.options["nav-border-style"]
              : undefined
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_id={element.id}
          label="Border Color"
          setting_name="[options][nav-border-color]"
          setting_type="color_v2"
          object_type="elements"
          value={
            element.options["nav-border-color"]
              ? element.options["nav-border-color"]
              : undefined
          }
          placeholder={
            variant.options["nav-border-color"]
              ? variant.options["nav-border-color"]
              : "#000"
          }
          condition={["dotted", "dashed", "solid"].includes(navBorderStyle)}
          show_reset={true}
          gradient={true}
        />

        {navBorderStyle && navBorderStyle !== "none" && (
          <div
            className="col-xs-12 some-vertical-space setting"
            style={{ marginBottom: "5px" }}
          >
            <div className="row">
              <div className="col-xs-12">
                <p className="field-title">Border Width</p>

                {["left", "top", "bottom", "right"].map((side) => {
                  const settingName = `[options][nav-border-width-${side}]`;
                  return (
                    <VariantBuilderSetting
                      key={settingName}
                      object={element}
                      object_id={element.id}
                      setting_name={settingName}
                      setting_type="number"
                      object_type="elements"
                      value={
                        _.isNil(element.options[`nav-border-width-${side}`]) ==
                        false
                          ? element.options[`nav-border-width-${side}`]
                          : undefined
                      }
                      placeholder={
                        variant.options[`nav-border-width-${side}`]
                          ? variant.options[`nav-border-width-${side}`]
                          : "0px"
                      }
                      col="3"
                      note={window.capitalizeFirstLetter(side)}
                      classNames="spacing-inputs"
                      min={0}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}

        <VariantBuilderSetting
          object={element}
          object_id={element.id}
          label="Corner Radius"
          setting_name="[options][nav-border-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
          object_type="elements"
          value={
            element.options["nav-border-radius"]
              ? element.options["nav-border-radius"]
              : undefined
          }
          show_reset={true}
        />

        {element.options["nav-border-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][nav-border-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={element}
                    object_id={element.id}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="elements"
                    value={
                      _.isNil(element.options[`nav-border-radius-${side}`]) ==
                      false
                        ? element.options[`nav-border-radius-${side}`]
                        : undefined
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder={
                      variant.options[`nav-border-radius-${side}`]
                        ? variant.options[`nav-border-radius-${side}`]
                        : "0px"
                    }
                    classNames="spacing-inputs"
                  />
                );
              }
            )}
          </div>
        )}

        <VariantBuilderSetting
          object={element}
          label="Links Spacing"
          setting_name="[options][nav-links-spacing]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-spacing"]
              ? element.options["nav-links-spacing"]
              : undefined
          }
          placeholder={
            variant.options["nav-links-spacing"]
              ? variant.options["nav-links-spacing"]
              : 25
          }
          min={0}
          max={100}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Links Spacing"
          setting_name="[options][nav-links-spacing-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-spacing-mobile"]
              ? element.options["nav-links-spacing-mobile"]
              : undefined
          }
          placeholder={
            element.options["nav-links-spacing"]
              ? element.options["nav-links-spacing"]
              : variant.options["nav-links-spacing-mobile"]
              ? variant.options["nav-links-spacing-mobile"]
              : variant.options["nav-links-spacing"]
              ? variant.options["nav-links-spacing"]
              : 25
          }
          min={0}
          max={100}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Logo" open={false}>
        <VariantBuilderSetting
          object={element}
          label="Size control"
          setting_name="[options][control-style]"
          setting_type="dropdown"
          object_type="elements"
          object_id={element.id}
          value={controlStyle}
          options={[
            { value: "width", text: "Width" },
            { value: "height", text: "Height" },
          ]}
          device="desktop"
          show_reset={element.options["control-style"] !== null}
        />

        <VariantBuilderSetting
          object={element}
          label="Size control"
          setting_name="[options][control-style-mobile]"
          setting_type="dropdown"
          object_type="elements"
          object_id={element.id}
          value={controlStyleMobile}
          placeholder={controlStyle}
          options={[
            { value: "width", text: "Width" },
            { value: "height", text: "Height" },
          ]}
          device="mobile"
          show_reset={element.options["control-style-mobile"] !== null}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][image-width]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label={"Logo Max Width"}
          value={element.options["image-width"]}
          device="desktop"
          condition={controlStyle !== "height"}
          placeholder={
            variant.options["logo-image-width"]
              ? variant.options["logo-image-width"]
              : 150
          }
          min={0}
          max={2560}
          allow_empty={true}
          range_step={"1"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][image-width-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label={"Logo Max Width"}
          condition={controlStyleMobile == "width"}
          placeholder={
            element.options["image-width"]
              ? element.options["image-width"]
              : variant.options["logo-image-width"]
              ? variant.options["logo-image-width"]
              : 150
          }
          value={
            element.options["image-width-mobile"]
              ? element.options["image-width-mobile"]
              : undefined
          }
          device="mobile"
          min={0}
          max={2560}
          allow_empty={true}
          range_step={"1"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][image-height]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label={"Logo Max Height"}
          value={element.options["image-height"]}
          device="desktop"
          condition={controlStyle == "height"}
          placeholder={
            variant.options["logo-image-height"]
              ? variant.options["logo-image-height"]
              : "Auto"
          }
          min={0}
          max={2560}
          allow_empty={true}
          range_step={"1"}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][image-height-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label={"Logo Max Height"}
          condition={controlStyleMobile == "height"}
          placeholder={
            element.options["image-height"]
              ? element.options["image-height"]
              : variant.options["logo-image-height"]
              ? variant.options["logo-image-height"]
              : "Auto"
          }
          value={
            element.options["image-height-mobile"]
              ? element.options["image-height-mobile"]
              : undefined
          }
          device="mobile"
          min={0}
          max={2560}
          allow_empty={true}
          range_step={"1"}
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse name="Links" open={false}>
        <VariantBuilderSetting
          object={element}
          label="Links Font Family"
          setting_name="[options][nav-links-font-family]"
          setting_type="select"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-font-family"]
              ? element.options["nav-links-font-family"]
              : undefined
          }
          placeholder={
            variant.options["nav-links-font-family"]
              ? variant.options["nav-links-font-family"]
              : undefined
          }
          option_groups={["System fonts", "Google fonts"]}
          options={[
            {
              value: "",
              text: "Theme font",
              group: "System fonts",
            },
            ...window.builder_fonts_dropdown,
          ]}
          col="8"
          callback={(new_value, old_value) => {
            ctas.builder.fonts.load_font_family(new_value);
          }}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][nav-links-font-weight]"
          setting_type="font_weight"
          label="Weight"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-font-weight"]
              ? element.options["nav-links-font-weight"]
              : undefined
          }
          col="4"
          classNames="no-padding-left"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Links Font Size"
          setting_name="[options][nav-links-font-size]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-font-size"]
              ? element.options["nav-links-font-size"]
              : undefined
          }
          placeholder={
            variant.options["nav-links-font-size"]
              ? variant.options["nav-links-font-size"]
              : 16
          }
          min={0}
          max={100}
          range_step={1}
          device="desktop"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Links Font Size"
          setting_name="[options][nav-links-font-size-mobile]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-font-size-mobile"]
              ? element.options["nav-links-font-size-mobile"]
              : undefined
          }
          placeholder={
            element.options["nav-links-font-size"]
              ? element.options["nav-links-font-size"]
              : variant.options["nav-links-font-size-mobile"]
              ? variant.options["nav-links-font-size-mobile"]
              : variant.options["nav-links-font-size"]
              ? variant.options["nav-links-font-size"]
              : 16
          }
          min={0}
          max={100}
          range_step={1}
          device="mobile"
          allow_empty={true}
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Links Font Color"
          setting_name="[options][nav-links-font-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-font-color"]
              ? element.options["nav-links-font-color"]
              : undefined
          }
          placeholder={
            variant.options["nav-links-font-color"]
              ? variant.options["nav-links-font-color"]
              : "#000"
          }
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          label="Links Hover Color"
          setting_name="[options][nav-links-hover-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-links-hover-color"]
              ? element.options["nav-links-hover-color"]
              : undefined
          }
          placeholder={
            variant.options["nav-links-hover-color"]
              ? variant.options["nav-links-hover-color"]
              : "#000"
          }
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse
        name="Mobile Menu"
        open={false}
        condition={contextData.device == "mobile"}
      >
        <VariantBuilderSetting
          object={element}
          label="Hamburger Icon Color"
          setting_name="[options][nav-hamburger-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-hamburger-color"]
              ? element.options["nav-hamburger-color"]
              : undefined
          }
          placeholder={
            variant.options["nav-hamburger-color"]
              ? variant.options["nav-hamburger-color"]
              : "#000"
          }
          device="mobile"
          show_reset={true}
        />
      </VariantBuilderPanelCollapse>

      <VariantBuilderPanelCollapse
        name="Mobile Menu Popover"
        open={false}
        condition={contextData.device == "mobile"}
      >
        <VariantBuilderSetting
          object={element}
          label="Padding"
          setting_name="[options][nav-menu-padding]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-menu-padding"]
              ? element.options["nav-menu-padding"]
              : undefined
          }
          placeholder={
            variant.options["nav-menu-padding"]
              ? variant.options["nav-menu-padding"]
              : 10
          }
          min={0}
          max={100}
          range_step={"1"}
          allow_empty={true}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Background Color"
          setting_name="[options][nav-menu-background-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-menu-background-color"]
              ? element.options["nav-menu-background-color"]
              : undefined
          }
          placeholder={
            variant.options["nav-menu-background-color"]
              ? variant.options["nav-menu-background-color"]
              : "Transparent"
          }
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_id={element.id}
          label="Border Style"
          setting_name="[options][nav-menu-border-style]"
          setting_type="border_style"
          object_type="elements"
          value={
            element.options["nav-menu-border-style"]
              ? element.options["nav-menu-border-style"]
              : undefined
          }
          device="mobile"
          show_reset={true}
        />

        <VariantBuilderSetting
          object={element}
          object_id={element.id}
          label="Border Color"
          setting_name="[options][nav-menu-border-color]"
          setting_type="color_v2"
          object_type="elements"
          value={
            element.options["nav-menu-border-color"]
              ? element.options["nav-menu-border-color"]
              : undefined
          }
          placeholder={
            variant.options["nav-menu-border-color"]
              ? variant.options["nav-menu-border-color"]
              : "#000"
          }
          condition={["dotted", "dashed", "solid"].includes(navMenuBorderStyle)}
          show_reset={true}
          gradient={true}
          device="mobile"
        />

        {navMenuBorderStyle && navMenuBorderStyle !== "none" && (
          <div
            className="col-xs-12 some-vertical-space setting"
            style={{ marginBottom: "5px" }}
          >
            <div className="row">
              <div className="col-xs-12">
                <p className="field-title">Border Width</p>

                {["left", "top", "bottom", "right"].map((side) => {
                  const settingName = `[options][nav-menu-border-width-${side}]`;
                  return (
                    <VariantBuilderSetting
                      key={settingName}
                      object={element}
                      object_id={element.id}
                      setting_name={settingName}
                      setting_type="number"
                      object_type="elements"
                      value={
                        _.isNil(
                          element.options[`nav-menu-border-width-${side}`]
                        ) == false
                          ? element.options[`nav-menu-border-width-${side}`]
                          : undefined
                      }
                      placeholder={
                        variant.options[`nav-menu-border-width-${side}`]
                          ? variant.options[`nav-menu-border-width-${side}`]
                          : "0px"
                      }
                      col="3"
                      note={window.capitalizeFirstLetter(side)}
                      classNames="spacing-inputs"
                      min={0}
                      device="mobile"
                    />
                  );
                })}
              </div>
            </div>
          </div>
        )}

        <VariantBuilderSetting
          object={element}
          object_id={element.id}
          label="Corner Radius"
          setting_name="[options][nav-menu-border-radius]"
          setting_type="border_radius"
          valueMappings={{
            none: "cf-not-rounded",
            some: "cf-slightly-rounded",
            full: "cf-fully-rounded",
            custom: "custom",
          }}
          object_type="elements"
          value={
            element.options["nav-menu-border-radius"]
              ? element.options["nav-menu-border-radius"]
              : undefined
          }
          device="mobile"
          show_reset={true}
        />

        {element.options["nav-menu-border-radius"] == "custom" && (
          <div className="col-xs-12">
            {["top-left", "top-right", "bottom-right", "bottom-left"].map(
              (side) => {
                const settingName = `[options][nav-menu-border-radius-${side}]`;
                return (
                  <VariantBuilderSetting
                    key={settingName}
                    object={element}
                    object_id={element.id}
                    setting_name={settingName}
                    setting_type="number"
                    object_type="elements"
                    value={
                      _.isNil(
                        element.options[`nav-menu-border-radius-${side}`]
                      ) == false
                        ? element.options[`nav-menu-border-radius-${side}`]
                        : undefined
                    }
                    min={0}
                    note={capitalizeFirstLetter(side).replace("-", " ")}
                    col="3"
                    placeholder={
                      variant.options[`nav-menu-border-radius-${side}`]
                        ? variant.options[`nav-menu-border-radius-${side}`]
                        : "0px"
                    }
                    classNames="spacing-inputs"
                    device="mobile"
                  />
                );
              }
            )}
          </div>
        )}

        <VariantBuilderSetting
          object={element}
          label="Shadow"
          setting_name="[options][nav-menu-shadow]"
          setting_type="shadow"
          show_reset={true}
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-menu-shadow"]
              ? element.options["nav-menu-shadow"]
              : undefined
          }
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][nav-menu-shadow-horizontal-distance]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Shadow Horizontal Distance"
          value={
            element.options["nav-menu-shadow-horizontal-distance"]
              ? element.options["nav-menu-shadow-horizontal-distance"]
              : undefined
          }
          condition={element.options["nav-menu-shadow"] == "custom"}
          min={-100}
          max={100}
          range_step={"1"}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][nav-menu-shadow-vertical-distance]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Shadow Vertical Distance"
          value={
            element.options["nav-menu-shadow-vertical-distance"]
              ? element.options["nav-menu-shadow-vertical-distance"]
              : undefined
          }
          condition={element.options["nav-menu-shadow"] == "custom"}
          min={-100}
          max={100}
          range_step={"1"}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][nav-menu-shadow-blur-radius]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Shadow Blur Radius"
          value={
            element.options["nav-menu-shadow-blur-radius"]
              ? element.options["nav-menu-shadow-blur-radius"]
              : undefined
          }
          condition={element.options["nav-menu-shadow"] == "custom"}
          min={0}
          max={100}
          range_step={"1"}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          setting_name="[options][nav-menu-shadow-spread-radius]"
          setting_type="range"
          object_type="elements"
          object_id={element.id}
          label="Shadow Spread Radius"
          value={
            element.options["nav-menu-shadow-spread-radius"]
              ? element.options["nav-menu-shadow-spread-radius"]
              : undefined
          }
          condition={element.options["nav-menu-shadow"] == "custom"}
          min={0}
          max={100}
          range_step={"1"}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Shadow Color"
          setting_name="[options][nav-menu-shadow-color]"
          setting_type="color_v2"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-menu-shadow-color"]
              ? element.options["nav-menu-shadow-color"]
              : undefined
          }
          placeholder="#000"
          condition={element.options["nav-menu-shadow"] == "custom"}
          show_reset={true}
          device="mobile"
        />

        <VariantBuilderSetting
          object={element}
          label="Inset shadow position"
          setting_name="[options][nav-menu-shadow-inset]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          value={
            element.options["nav-menu-shadow-inset"]
              ? element.options["nav-menu-shadow-inset"]
              : "false"
          }
          condition={element.options["nav-menu-shadow"] == "custom"}
          device="mobile"
        />
      </VariantBuilderPanelCollapse>
    </React.Fragment>
  );
};

export default ElementSettingsNavigationDesign;
